import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
  theme,
  ButtonSize,
} from '@bechtel/gds';

import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { CloseRodRequestByStencilIdErrorProps } from './types';
import { map } from 'lodash';
import { CloseRodRequestByStencilIdError, CloseRodRequestByStencilIdErrorCode } from '@bechtel/types';

const getErrorMessage = (error: CloseRodRequestByStencilIdErrorCode) => {
  switch (error) {
    case CloseRodRequestByStencilIdErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>You do not have permission to close rod request.</Trans>;
    case CloseRodRequestByStencilIdErrorCode.SERVICE_PROXY_ERROR:
      return <Trans>Server proxy error.</Trans>;
    case CloseRodRequestByStencilIdErrorCode.ROD_REQUEST_ALREADY_CLOSED:
      return <Trans>Rod request already closed.</Trans>;
    case CloseRodRequestByStencilIdErrorCode.ROD_REQUEST_ALREADY_DELETED:
      return <Trans>Rod request already deleted.</Trans>;
    case CloseRodRequestByStencilIdErrorCode.CLOSE_ROD_REQUEST_ERRORED:
      return <Trans>Some error has occured. Please try again after sometime.</Trans>;
    case CloseRodRequestByStencilIdErrorCode.ALL_ISSUED_CADDIES_NOT_RETURNED:
      return <Trans>All issued caddies not returned.</Trans>;
    case CloseRodRequestByStencilIdErrorCode.INVALID_STENCIL_ID:
      return <Trans>Invalid stencil id.</Trans>;
    case CloseRodRequestByStencilIdErrorCode.NO_ROD_REQUEST_FOUND:
      return <Trans>Open rod request not found.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const ClosedRodRequestByStencilIdError: FC<CloseRodRequestByStencilIdErrorProps> = ({ errors, close }) => {
  return (
    <Modal visible size={ModalSize.LARGE}>
      <ModalHeader title={t`Close Rod Request Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody style={{ height: '275px' }}>
        <Box pb={{ sm: '500' }} flexGrow={{ sm: 1 }} flexDirection={{ sm: 'column' }} css={{ minHeight: '150px' }}>
          {errors instanceof ApolloError && (
            <Box p={{ sm: '500' }}>
              <Text>
                <Trans>Network error has occured.Please close button and try again.</Trans>
              </Text>
            </Box>
          )}
          {errors instanceof Array &&
            map(errors, (error: CloseRodRequestByStencilIdError) => {
              return (
                error && (
                  <Box
                    css={{
                      borderBottom: errors?.length > 1 ? `1px solid ${theme.colors.grey[300]}` : '',
                      width: '100%',
                    }}
                  >
                    <Box justifyContent={{ sm: 'space-between' }} p={{ sm: '500' }}>
                      <Box mr={{ sm: '200' }}>
                        <Text size="500" weight="600">
                          {error?.rodRequest && error?.rodRequest.requestNumber} -
                        </Text>
                      </Box>

                      <Box ml={{ sm: '200' }}>
                        <Text>{getErrorMessage(error?.errorCode)}</Text>
                      </Box>
                    </Box>
                  </Box>
                )
              );
            })}
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button
              appearance={ButtonAppearance.SECONDARY}
              onClick={close}
              css={`
                padding-left: ${({ theme }) => theme.spacings['600']};
                padding-right: ${({ theme }) => theme.spacings['600']};
              `}
            >
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
